const equalId = (a, b) => {
	const id1 = a?.id ?? a;
	const id2 = b?.id ?? b;
	return id1 == id2;
};

module.exports = equalId;
